export function getGraphData(data = []) {
  for (let a = 0; a < data.length - 1; a++) {
    if (data[a][1] != 0) {
      return data;
    }
  }
  return getDummyData(data?.length);
}

function getDummyData(length) {
  let data = [];
  for (let a = 0; a < length - 1; a++) {
    data.push([10, 10]);
  }
  return data;
}
